import { render } from "./FollowerList.vue?vue&type=template&id=1363c9ab"
import script from "./FollowerList.vue?vue&type=script&lang=js"
export * from "./FollowerList.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Xoan\\asp-user\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__